import styled from '@mui/material/styles/styled';

export const Container = styled('div')`
  height: 100vh;
  display: flex;
  flex-direction: column;
`;
